// extracted by mini-css-extract-plugin
export default {"varSpUp8":"3rem","varSpDown3":"0.25rem","margin":"margin--8cf0b","innerAlign":"innerAlign--75967","noBorder":"noBorder--b65be"};